import React from "react";
import { Instagram, Music2, BadgeCheck } from "lucide-react";
import { formatFollowers } from "@/lib/api";

const ICON = { instagram: Instagram, tiktok: Music2 };

/** Public, read-only display of a business's verified social connections. */
export function BusinessVerifiedSocials({ socials, testid = "business-verified-socials", className = "", showPosts = false }) {
  if (!socials?.length) return null;
  const posts = showPosts
    ? socials.flatMap((s) => (s.recent_media || []).map((m) => ({ ...m, platform: s.platform }))).filter((m) => m.thumbnail).slice(0, 6)
    : [];
  return (
    <div data-testid={testid} className={className}>
      <div className="flex flex-wrap gap-2">
        {socials.map((s) => {
          const M = ICON[s.platform] || BadgeCheck;
          return (
            <span
              key={s.id}
              data-testid={`verified-social-${s.platform}`}
              className="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700"
            >
              <M className="h-3.5 w-3.5" /> @{s.username}
              {s.followers != null && (
                <span className="font-medium text-emerald-600/80">· {formatFollowers(s.followers)} followers</span>
              )}
              <BadgeCheck className="h-3.5 w-3.5" title="Verified via official Instagram connection" />
            </span>
          );
        })}
      </div>
      {posts.length > 0 && (
        <div data-testid={`${testid}-posts`} className="mt-3 flex gap-2 overflow-x-auto no-scrollbar">
          {posts.map((m) => (
            <a key={m.id} href={m.permalink} target="_blank" rel="noreferrer"
              className="h-16 w-16 shrink-0 overflow-hidden rounded-lg bg-zinc-100 ring-1 ring-zinc-200">
              <img src={m.thumbnail} alt="" referrerPolicy="no-referrer" className="h-full w-full object-cover" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
